















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CustomerImportBanner extends Vue {
  @Prop() customersAmount!: number;
  @Prop() description!: string;

  get tPrefix() {
    return 'customerImport.overview';
  }

  get descriptionHTML() {
    if (this.$mobileCheck())
      return `<b class='customer-import-banner__customers'>+${
        this.customersAmount
      }</b>${this.minimalizeFirstLetterDescription(this.description)}`;
    return this.description;
  }

  minimalizeFirstLetterDescription(str: string) {
    return '<b>' + str[3].toLowerCase() + str.substr(4);
  }
}
